// import Swiper bundle with all modules installed
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
// import styles bundle
import 'swiper/css';


const swiper = new Swiper('.swiper', {
	loop: true,
	modules: [Autoplay, Navigation, Pagination],
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	navigation: {
	  nextEl: '.swiper-next',
	  prevEl: '.swiper-prev',
	},
 });
